export default __webpack_public_path__ + "static/media/trident-4.3fd46895.jpg";